(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["db-product-options"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(scope){
    scope.querySelectorAll('[data-db-options]').forEach(picker=>{
      if(picker.dataset.ready)return;
      picker.dataset.ready='true';
      const form=picker.closest('form');
      const fields=[...picker.querySelectorAll('[data-option-position]')];
      const variants=JSON.parse(picker.querySelector('[data-variants]').textContent);
      const id=picker.querySelector('[data-variant-id]');
      const submit=form.querySelector('button[type="submit"]');
      const status=picker.querySelector('[data-option-status]');
      const container=picker.closest('[data-db-product]')||picker.closest('[data-product]');
      function update(announce){
        const values=fields.map(f=>f.value);
        const complete=values.every(Boolean);
        const variant=complete?variants.find(v=>fields.length===0||v.options.every((o,i)=>o===values[i])):null;
        id.value=variant?.id||'';id.disabled=!variant?.available;submit.disabled=!variant?.available;
        submit.textContent=variant&&!variant.available?picker.dataset.sold:picker.dataset.add;
        status.textContent=complete&&!variant?picker.dataset.unavailable:complete&&variant&&!variant.available?picker.dataset.sold:announce&&!complete?picker.dataset.choose:'';
        if(announce){
          const colorField=fields.find(f=>f.hasAttribute('data-color-option'));
          const colorIndex=colorField?Number(colorField.dataset.optionPosition):-1;
          const color=colorField?.value;
          const imageVariant=variant?.image?variant:color?variants.find(v=>v.options[colorIndex]===color&&v.image):null;
          if(imageVariant){
            const image=container?.querySelector('.dbc-product-image');
            if(image){image.removeAttribute('srcset');image.src=imageVariant.image;}
            const media=[...container.querySelectorAll('[data-media]')];
            if(media.some(m=>m.dataset.media===imageVariant.media)){
              media.forEach(m=>{m.hidden=m.dataset.media!==imageVariant.media;if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});
              container.querySelectorAll('[data-thumbnail]').forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.thumbnail===imageVariant.media)));
            }
          }
          if(color){const label=container?.querySelector('[data-product-color]');if(label)label.textContent=color;}
        }
        if(variant){
          const price=container?.querySelector('[data-db-price]');if(price)price.textContent=variant.price;
          if(announce)picker.dispatchEvent(new CustomEvent('db:variant',{bubbles:true,detail:{variant,options:values}}));
        }
      }
      fields.forEach(field=>field.addEventListener('change',()=>update(true)));
      form.addEventListener('submit',e=>{update(true);if(id.disabled){e.preventDefault();fields.find(f=>!f.value)?.focus();}});
      update(false);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
